import { styled } from '@mui/material/styles'

/* eslint-enable no-undef, no-unused-vars, no-empty-pattern */

export const FooterRoot = styled('footer')(({ theme }) => ({
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex',
  borderTop: `2px solid ${theme.palette.primary.main}`,
  height: '5rem',
  alignCenter: true,
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    height: 'auto',
  },
}))

export const FooterText = styled('div')(({ theme }) => ({
  '& a': {
    marginLeft: '0.6rem',
    textDecoration: 'none',
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  [theme.breakpoints.down('sm')]: {
    textAlign: 'center',
  },
}))

export const FooterLogo = styled('img')(({ theme }) => ({
  alignCenter: true,
  height: '55%',
  [theme.breakpoints.down('sm')]: {
    position: 'relative',
    width: 'clamp(6rem, 60%, 12rem)',
    height: 'unset',
    marginTop: '1rem',
  },
}))

/* eslint-disable no-undef, no-unused-vars, no-empty-pattern */
